module.exports = __webpack_public_path__ + "images/category_lp/watch/omega/assessment_achievements/4_8d6329a735deffa8e309c8e2f69865f3.png";